import * as ACTION_TYPES from '../actions/action_types'

const initialState = {
    user_name: '',
    user_surname: '',
    user_position: '',
    user_email: '',
    user_phone: '',
    user_image: '',
}

const UserReducer = (state = initialState, action) => {
    switch(action.type) {
        case ACTION_TYPES.USER_NAME:
            return {
                ...state,
                user_name: action.payload
            }
        case ACTION_TYPES.USER_SURNAME:
            return {
                ...state,
                user_surname: action.payload
            }
        case ACTION_TYPES.USER_POSITION:
            return {
                ...state,
                user_position: action.payload
            }
        case ACTION_TYPES.USER_EMAIL:
            return {
                ...state,
                user_email: action.payload
            }
        case ACTION_TYPES.USER_PHONE:
            return {
                ...state,
                user_phone: action.payload
            }
        case ACTION_TYPES.USER_IMAGE:
            return {
                ...state,
                user_image: action.payload
            }
        default:
            return state
    }
}

export default UserReducer;